import { Brand } from '@bonhams1793/bonhams-typescript'
import { Fragment, memo } from 'react'
import isEqual from 'react-fast-compare'

import { FireBackToTop } from '@nx/fire/back-to-top'
import { useScrollPositionRestore } from '@nx/fire/scroll-position'
import { AuctionLot } from '@nx/global-types'

import { SellingPromoCard } from '@web/components/search/SellingPromoCard'
import { useGetUser } from '@web/helpers/api/user'

import { mapLotToLotCardItem } from '../../../helpers/api'
import { LotCard } from '../LotCard'
import { StyledGrid } from './LotGrid.styles'

export const LotGrid = memo(
  function LotGrid({
    lots,
    page = 1,
    isShowingLotId,
    isBackTopShown = false,
    showSellingPromoCard = false,
    sellingPromoCardTracking,
    ...props
  }: LotGridProps) {
    const { data: user } = useGetUser()
    const { elementsToRecordHeightRefs } = useScrollPositionRestore()

    return (
      <>
        {isBackTopShown && (
          <FireBackToTop id="lot-gallery" jumpToName="lot gallery" />
        )}
        <StyledGrid
          id={`page${page}`}
          data-testid={`page${page}`}
          $extraMargin={!isBackTopShown}
        >
          {lots.map(mapLotToLotCardItem).map((lot, index) => (
            <Fragment
              key={
                lot.biddingEngine === 'AM'
                  ? `${lot.auctionId}-${lot.lotId}-${!!user}-${lot.lotUniqueId}`
                  : `${lot.lotUniqueId}`
              }
            >
              <LotCard
                ref={(el) => {
                  if (el) {
                    elementsToRecordHeightRefs.current[lot.lotUniqueId] = el
                  }
                }}
                isShowingLotId={!lot.isPreview && isShowingLotId}
                lot={lot}
                isFollowButtonDisplayed={[
                  Brand.bonhams,
                  Brand.cars,
                  Brand.cornette,
                  Brand.skinner,
                ].includes(lot.brand)}
                isBackTopShown={isBackTopShown}
                {...props}
              />
              {showSellingPromoCard && (index + 1) % 15 === 0 && (
                <SellingPromoCard
                  sellingPromoCardTracking={sellingPromoCardTracking}
                />
              )}
            </Fragment>
          ))}
        </StyledGrid>
      </>
    )
  },
  isEqual // deep comparison of props
)

type LotGridProps = {
  lots: AuctionLot[]
  page?: number
  isBackTopShown?: boolean
  lotTracking: { category: string }
  isShowingLotId: boolean
  showSellingPromoCard?: boolean
  sellingPromoCardTracking?: {
    category: string
  }
  showBidding?: boolean
}
